<template>
  <transition v-if="isShowAnimation" name="slide">
    <div class="sticky-buttons-wrapper" :class="{ loading }" v-if="showElement">
      <slot></slot>
    </div>
  </transition>
  <div class="sticky-buttons-wrapper" :class="{ loading }" v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isShowAnimation: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showElement: false
    }
  },
  mounted () {
    this.showElement = true
  },
  beforeDestroy () {
    this.showElement = false
  }
}
</script>

<style lang="scss">
.sticky-buttons-wrapper {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 80;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 40px;
  box-shadow: 1px 0px 10px 0px #00000017;
  margin-left: 0px;
  gap: 16px;
}

.slide-enter-active,
.slide-leave-active {
  transition: margin-left 0.5s;
}

.slide-enter,
.slide-leave-to {
  margin-left: 100%;
}
</style>
